import { Card } from "antd";
import { useTranslation } from "react-i18next";
import BackNavigationArrow from "../../../common/components/views/BackNavigationArrow";
import ContentWrapper from "../../../common/modules/wrappers/ContentWrapper";
import { InstitutionForm } from "../components/forms/InstitutionForm";

export const InstitutionCreateContainer = () => {
  const { t } = useTranslation();

  return (
    <ContentWrapper>
      <Card
        className="card-box"
        title={
          <BackNavigationArrow>
            <h2 className="margin-bottom-large">{t("institution.titles.new")}</h2>
          </BackNavigationArrow>
        }
      >
        <InstitutionForm />
      </Card>
    </ContentWrapper>
  );
};
